import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  catchError, Observable, throwError
} from 'rxjs';
import { IAppConfig } from '../shared/interfaces/app-config';
import { AppConfigService } from './app-config.service';
import { User } from '../shared/models/user';
import { IImpersonateGetUserPayload } from '../shared/interfaces/impersonate-get-user-payload';
import { IImpersonateUsersResponse } from '../shared/interfaces/impersonate-users-response';
import { ApiResponse } from '../shared/interfaces/api-response';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  config: IAppConfig;

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService,
  ) {
    this.config = this.appConfigService.getConfig();
  }

  getUserInfo(): Observable<User> {
    return this.http
      .get<User>(`${this.config.apiUrl}/User/user`)
      .pipe(catchError(this.handleError));
  }

  getUsersToImpersonate(payload: IImpersonateGetUserPayload): Observable<IImpersonateUsersResponse> {
    return this.http
      .post<IImpersonateUsersResponse>(`${this.config.apiUrl}/User/GetUsersListToImpersonate`, payload )
      .pipe(
        catchError(this.handleError)
      );
  }

  impersonateUser(userName: string): Observable<ApiResponse<string>> {
    return this.http
      .get<ApiResponse<string>>(`${this.config.apiUrl}/User/Impersonate/${userName}`)
      .pipe(
        catchError(this.handleError)
      );
  }

  endImpersonation(): Observable<ApiResponse<null>> {
    return this.http
      .get<ApiResponse<null>>(`${this.config.apiUrl}/User/EndImpersonation`)
      .pipe(
        catchError(this.handleError)
      );
  }

  // Error handling
  handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage: string = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }

    // this.userInfoService.getManager().signinRedirect();
    return throwError(() => {
      return errorMessage;
    });
  }
}
